import React from 'react'
import { I18n } from 'react-redux-i18n'
import StarRatingComponent from 'react-star-rating-component'

export default ({ isShow, onHide, serviceTxn }) => {
  const label = I18n.t('stationReportScene.feedbackModal')

  if (!isShow) return null

  return (
    <div>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50"
        onClick={onHide}
      ></div>

      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-lg w-full">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900">
              Complain Message
            </h3>
            <button
              onClick={onHide}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="px-6 py-6">{renderModalBody(serviceTxn, label)}</div>

          <div className="flex justify-end gap-3 px-6 py-4 bg-gray-50 border-t border-gray-200 rounded-b-lg">
            <button
              onClick={onHide}
              className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 transition-all"
            >
              {I18n.t('action.cancel')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const renderModalBody = (serviceTxn, label) => {
  if (serviceTxn) {
    return (
      <div>
        <div className="grid grid-cols-3 gap-4 mb-4">
          <div className="col-span-1 text-sm font-medium text-gray-700">
            {label.customerSatisfactionRate}
          </div>
          <div className="col-span-2">
            <StarRatingComponent
              name="customerSatisfactionRate"
              value={serviceTxn.serviceInfo.customerSatisfactionRate}
              starCount={3}
              editing={false}
            />
          </div>
        </div>
        <textarea
          disabled
          value={serviceTxn.serviceInfo.note}
          type="text"
          name="note"
          className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-gray-50 text-gray-900 resize-y focus:outline-none"
          rows="8"
        />
      </div>
    )
  }
  return null
}
